import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { FiTrash2, FiSearch, FiEye, FiPhone, FiMail } from "react-icons/fi";

import {
  fetchResumes,
  deleteMessage,
} from "../../redux/actions/WebAdminActions";

const ResumeDetails = () => {
  const dispatch = useDispatch();

  const { resumes, loading, error } = useSelector((state) => state.webAdmin);

  const [searchTerm, setSearchTerm] = useState("");
  const [confirmDeleteOpen, setConfirmDeleteOpen] = useState(false);
  const [deleteId, setDeleteId] = useState(null);

  // const [resumeModalOpen, setResumeModalOpen] = useState(false);
  // const [resumeUrl, setResumeUrl] = useState("");

  useEffect(() => {
    dispatch(fetchResumes());
  }, [dispatch]);

  const handleDelete = (id) => {
    setDeleteId(id);
    setConfirmDeleteOpen(true);
  };

  const confirmDelete = () => {
    dispatch(deleteMessage("/v1/api/admin/deleteJobApplication", deleteId));
    setConfirmDeleteOpen(false);
    setDeleteId(null);
  };

  // const openResumeModal = (url) => {
  //   setResumeUrl(url);
  //   setResumeModalOpen(true);
  // };

  const filteredApplications = resumes.filter(
    (a) =>
      a.full_name.toLowerCase().includes(searchTerm.toLowerCase()) ||
      a.email.toLowerCase().includes(searchTerm.toLowerCase()) ||
      a.job_title.toLowerCase().includes(searchTerm.toLowerCase()) ||
      a.department.toLowerCase().includes(searchTerm.toLowerCase()),
  );

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900 p-6">
      <div className="mb-6">
        <h1 className="text-3xl font-bold text-gray-900 dark:text-white mb-1">
          Resume Applications
        </h1>
        <p className="text-gray-600 dark:text-gray-400">
          View and manage job applications received from portfolio website
        </p>
      </div>

      {/* Search */}
      <div className="mb-6">
        <div className="relative max-w-md">
          <FiSearch className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" />
          <input
            type="text"
            placeholder="Search by name, email, job title..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="w-full pl-10 pr-4 py-3 bg-white dark:bg-gray-700 border border-gray-300 dark:border-gray-600 rounded-xl shadow-sm focus:ring-2 focus:ring-blue-500 text-gray-900 dark:text-white"
          />
        </div>
      </div>

      {loading && (
        <p className="text-gray-600 dark:text-gray-300">
          Loading applications...
        </p>
      )}
      {error && <p className="text-red-500 mb-4">{error}</p>}

      {/* Table */}
      <div className="overflow-x-auto shadow-lg rounded-2xl border border-gray-200 dark:border-gray-700">
        <table className="min-w-full bg-white dark:bg-gray-800 border-collapse">
          <thead className="bg-gray-100 dark:bg-gray-700">
            <tr>
              <th className="px-4 py-4 text-left font-semibold text-gray-800 dark:text-white">
                #
              </th>
              <th className="px-4 py-4 text-left font-semibold text-gray-800 dark:text-white">
                Candidate
              </th>
              <th className="px-4 py-4 text-left font-semibold text-gray-800 dark:text-white">
                Job Details
              </th>
              <th className="px-4 py-4 text-left font-semibold text-gray-800 dark:text-white">
                Professional Info
              </th>
              <th className="px-4 py-4 text-left font-semibold text-gray-800 dark:text-white">
                Resume
              </th>
              <th className="px-4 py-4 text-center font-semibold text-gray-800 dark:text-white">
                Actions
              </th>
            </tr>
          </thead>

          <tbody className="divide-y divide-gray-100 dark:divide-gray-700">
            {filteredApplications.map((app, index) => (
              <tr
                key={app.id}
                className="hover:bg-gray-50 dark:hover:bg-gray-700/50"
              >
                <td className="px-4 py-4 text-sm text-gray-500 dark:text-gray-400">
                  {index + 1}
                </td>

                <td className="px-4 py-4">
                  <div className="font-medium text-gray-900 dark:text-white">
                    {app.full_name}
                  </div>
                  <div className="flex items-center gap-2 text-sm text-orange-600 dark:text-orange-500/70 italic">
                    <FiMail className="text-orange-600 dark:text-orange-500/70" size={14} />
                    <span>{app.email}</span>
                  </div>
                  <div className="flex items-center gap-2 text-xs font-medium text-gray-600 dark:text-gray-400 italic">
                    <FiPhone className="text-gray-600 dark:text-gray-400" size={12} />
                    <span>{app.phone}</span>
                  </div>
                </td>

                <td className="px-4 py-4">
                  <div className="font-semibold text-blue-700 dark:text-blue-300">
                    {app.job_title}
                  </div>
                  <div className="text-xs uppercase tracking-wider dark:text-gray-300">
                    {app.department}
                  </div>
                </td>

                <td className="px-4 py-4 text-sm dark:text-gray-300">
                  <span>
                    Exp: <b>{app.experience_years} yrs</b>
                  </span>
                  <br />
                  <span>
                    CTC: <b>₹{app.current_ctc}</b>
                  </span>
                  <br />
                  <span>
                    Notice: <b>{app.notice_period}d</b>
                  </span>
                </td>

                <td className="px-4 py-4">
                  <button
                    onClick={() =>
                      window.open(
                        `${process.env.REACT_APP_API_BASE_URL}${app.resume_file}`,
                        "_blank",
                      )
                    }
                    className="inline-flex items-center gap-2 px-3 py-1.5 text-sm font-medium text-blue-600 dark:text-blue-400 border dark:hover:text-white border-blue-500 rounded-lg hover:bg-blue-600 hover:text-white transition-all"
                  >
                    <FiEye /> View
                  </button>
                </td>

                <td className="px-4 py-4 text-center">
                  <button
                    onClick={() => handleDelete(app.id)}
                    className="inline-flex items-center gap-1.5 px-3 py-1.5 border border-red-500 text-red-600 hover:bg-red-600 hover:text-white rounded-lg"
                  >
                    <FiTrash2 size={14} />
                    <span className="text-xs font-bold uppercase">Delete</span>
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Delete Modal */}
      {confirmDeleteOpen && (
        <div className="fixed inset-0 bg-black/60 flex items-center justify-center z-50 p-4">
          <div className="bg-white dark:bg-gray-800 rounded-2xl max-w-md w-full p-8">
            <h3 className="text-xl font-bold text-center mb-2 dark:text-white">
              Delete Application
            </h3>
            <p className="text-center mb-8 dark:text-gray-300">
              Are you sure? This action cannot be undone.
            </p>
            <div className="flex gap-4">
              <button
                onClick={() => setConfirmDeleteOpen(false)}
                className="flex-1 bg-gray-100 py-2.5 rounded-xl"
              >
                Cancel
              </button>
              <button
                onClick={confirmDelete}
                className="flex-1 bg-red-500 text-white py-2.5 rounded-xl"
              >
                Delete
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ResumeDetails;
